import React from 'react';
import { Button } from 'antd';
import {
  LeftOutlined,
  CheckOutlined,
  UserOutlined,
  FileDoneOutlined,
  DollarCircleOutlined
} from '@ant-design/icons';
import dayjs from 'dayjs';

const ClaimHeader = ({ data, onBack }) => {
  const getStepStatus = (stepName) => {
    const statuses = ['formulario enviado', 'en validación', 'aprobado para pago', 'pagado'];
    let currentStatus = (data.status || 'formulario enviado').toLowerCase();
    if (currentStatus === 'corrección solicitada') currentStatus = 'en validación';

    const currentIndex = statuses.indexOf(currentStatus);
    const stepIndex = statuses.indexOf((stepName || '').toLowerCase());

    if (stepIndex < currentIndex) return 'completed';
    if (stepIndex === currentIndex) return 'active';
    return 'pending';
  };

  const getLineStatus = (stepName) => {
    const statuses = ['formulario enviado', 'en validación', 'aprobado para pago', 'pagado'];
    let currentStatus = (data.status || 'formulario enviado').toLowerCase();
    if (currentStatus === 'corrección solicitada') currentStatus = 'en validación';

    const currentIndex = statuses.indexOf(currentStatus);
    const stepIndex = statuses.indexOf((stepName || '').toLowerCase());

    if (currentIndex === -1 && stepIndex === 0) return 'pending'; // Fallback
    return stepIndex <= currentIndex ? 'completed' : 'pending';
  };

  const getStatusTimestamp = (stepName) => {
    if (!data.statusHistory || !Array.isArray(data.statusHistory)) {
      if (stepName.toLowerCase() === 'formulario enviado' && data.createdAt) {
        return dayjs(data.createdAt).format('DD/MM/YYYY hh:mm a');
      }
      return stepName.toLowerCase() === 'formulario enviado' ? '--/--/---- --:--' : '';
    }

    let searchStatus = stepName.toLowerCase();
    
    const log = data.statusHistory.find(h => {
      let hStatus = (h.status || '').toLowerCase();
      if (searchStatus === 'en validación' && hStatus === 'corrección solicitada') {
        return true;
      }
      return hStatus === searchStatus;
    });

    if (log && log.createdAt) {
      return dayjs(log.createdAt).format('DD/MM/YYYY hh:mm a');
    }
    
    if (stepName.toLowerCase() === 'formulario enviado' && data.createdAt) {
      return dayjs(data.createdAt).format('DD/MM/YYYY hh:mm a');
    }

    return stepName.toLowerCase() === 'formulario enviado' ? '--/--/---- --:--' : '';
  };

  return (
    <>
      <div className="claim-detail-header">
        <h1 className="claim-detail-title">
          <Button
            className="claim-detail-back-btn"
            type="text"
            icon={<LeftOutlined style={{ fontSize: 18 }} />}
            onClick={onBack}
            title="Regresar"
            aria-label="Regresar"
          />
          Validación de Información del Ganador
        </h1>
        <p className="claim-detail-subtitle" style={{ marginLeft: 30 }}>
          Revisa la información enviada por el ganador y decide la acción a realizar.
        </p>
      </div>

      <div className="claim-card">
        <div className="claim-top-section">
          
          <div className="claim-top-info">
            <div className="claim-info-item">
              <span className="claim-info-label">ID de reclamo</span>
              <span className="claim-info-value highlight">REC-{data.createdAt ? dayjs(data.createdAt).format('YYYY') : '----'}-000{data.id || 'X'}</span>
            </div>
            
            <div className="claim-info-item">
              <span className="claim-info-label">Fecha de registro</span>
              <span className="claim-info-value">{data.createdAt ? dayjs(data.createdAt).format('DD/MM/YYYY hh:mm a') : '--/--/---- --:--'}</span>
            </div>
            
            <div className="claim-info-item">
              <span className="claim-info-label">Competencia</span>
              <span className="claim-info-value">{data.competitionVideo?.competition?.name || data.competitionVideo?.competition?.description || 'Competencia'}</span>
            </div>
            
            <div className="claim-info-item">
              <span className="claim-info-label">Estado actual</span>
              <div className="claim-status-pill">{data.status}</div>
            </div>
          </div>

          <div className="claim-stepper">
            <div className={`claim-step ${getStepStatus('Formulario Enviado')}`}>
              <div className="claim-step-icon"><CheckOutlined /></div>
              <div className="claim-step-title">Formulario<br/>enviado</div>
              <div className="claim-step-date">
                {getStatusTimestamp('Formulario Enviado')}
              </div>
            </div>

            <div className={`claim-stepper-line flex-line ${getLineStatus('En Validación')}`}></div>
            
            <div className={`claim-step ${getStepStatus('En Validación')}`}>
              <div className="claim-step-icon"><UserOutlined /></div>
              <div className="claim-step-title">En Validación</div>
              <div className="claim-step-date">
                {data.status === 'Corrección Solicitada' ? (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <span style={{ color: '#f59e0b', fontWeight: 600, fontSize: '11px', lineHeight: 1.2 }}>Corrección Solicitada</span>
                    <span style={{ marginTop: '2px' }}>{getStatusTimestamp('Corrección Solicitada') || getStatusTimestamp('En Validación')}</span>
                  </div>
                ) : (
                  getStatusTimestamp('En Validación')
                )}
              </div>
            </div>

            <div className={`claim-stepper-line flex-line ${getLineStatus('Aprobado para Pago')}`}></div>
            
            <div className={`claim-step ${getStepStatus('Aprobado para Pago')}`}>
              <div className="claim-step-icon"><FileDoneOutlined /></div>
              <div className="claim-step-title">Aprobado para<br/>pago</div>
              <div className="claim-step-date">
                {getStatusTimestamp('Aprobado para Pago')}
              </div>
            </div>

            <div className={`claim-stepper-line flex-line ${getLineStatus('Pagado')}`}></div>
            
            <div className={`claim-step ${getStepStatus('Pagado')}`}>
              <div className="claim-step-icon"><DollarCircleOutlined /></div>
              <div className="claim-step-title">Pago<br/>realizado</div>
              <div className="claim-step-date">
                {getStatusTimestamp('Pagado')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClaimHeader;
